import { PropTypes } from "prop-types";

import Badge from "../Badge";

import "./profile.scss";

const Profile = ({ firstName, lastName }) => {
  return (
    <div className="profile">
      <div className="profile__avatar">
        <Badge
          value={firstName?.charAt(0)}
          variant="secondary"
          title={`${firstName} ${lastName}`}
        />
      </div>
      <div className="profile__info">
        <span className="profile__name">
          {firstName}
          <br />
          {lastName}
        </span>
      </div>
    </div>
  );
};

Profile.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string,
};

Profile.defaultProps = {
  firstName: "",
  lastName: "",
};

export default Profile;
